/**
 * @module Services Value Props
 * @description 50/50 Value Props Section
 */
import PropTypes from "prop-types";
import Tooltip from "@/blocks/Tooltip";
import styles from "./ServicesValueProps.module.css";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const {
    subtitle = "Frontier internet service availability varies by location, but you can explore the services we offer near you.",
  } = props;

  return (
    <section className={`component ${styles.component}`}>
      <div className="l-container">
        <div className={`component__header ${styles.component__header}`}>
          <div className="g-row g-row--vertical-center">
            <div className="g-col g-col--one-half--large">
              <h2 className={styles.component__title}>
                What does <br /> Frontier offer?
              </h2>
            </div>
            <div className="g-col g-col--one-half--large">
              <p
                className={`component__subtitle ${styles.component__subtitle}`}
              >
                {subtitle}
              </p>
            </div>
          </div>
          {/* <!-- .g-row --> */}
        </div>
        {/* <!-- .component__header --> */}

        <div className={`component__body ${styles.component__body}`}>
          <div className={styles.component__blocks}>
            <div className={styles.component__block}>
              <div className={styles.component__blockText}>
                <span className={`icon icon-wifi ${styles.component__icon}`} />
                <h3 className={styles.component__blockTitle}>
                  Frontier Internet
                </h3>
                <p className={styles.component__blockContent}>
                  Connect to network ready internet with zero data caps or
                  overage charges no matter what.
                  <Tooltip disclosure="data-caps" />
                </p>
              </div>
            </div>

            <div className={styles.component__block}>
              <div className={styles.component__blockText}>
                <span
                  className={`icon icon-phone-outline ${styles.component__icon}`}
                />
                <h3 className={styles.component__blockTitle}>
                  Frontier Home Phone
                </h3>
                <p className={styles.component__blockContent}>
                  Get clear home phone service to stay in touch. With a Frontier
                  Home Phone, enjoy easy-to-use features like voicemail and
                  caller ID, plus unlimited local and nationwide calling.
                  <span data-legal="frontier-voice-line" />
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- .component__body --> */}
      </div>
    </section>
  );
};

Component.propTypes = {
  subtitle: PropTypes.string,
};

export default Component;
